import * as React from 'react';
import { connect } from 'react-redux';
import SalesHeader from '~/apps/pos/mobile/components/sales/SaleHeader';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import Button from '~/common/elements/mobile/Button';
import { buttonSize, buttonStyle } from '~/common/elements/mobile/consts';
import { navigate } from '~/router';


class SalePrintResult extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.handleActions = this.handleActions.bind(this);
  }

  handleActions(actionKey) {
    switch (actionKey) {
      case 'print-close':
        navigate('pos.mobile.history');
        break;

      case 'other':
        alert('Other');
        break;

      default:
        console.warn(`>>> Not action key: ${actionKey} !!!`)
    }
  }

  render() {

    return (
      <PageMobileWrapper>
        <SalesHeader
          title={`Printing Status`}
          customStyleTitle={{ paddingTop: 20 }}
        />

        <BodyWrapper>
          <div className="m__ol--dbtns">
            <div
              className="m__body__titl--lg"
              style={{ color: 'green', fontSize: 24 }}
            >The receipt was printed successfully
            </div>
            <FooterWrapper
              customStyle={{ position: 'absolute' }}
            >
              <div
                className="m__foot__btns"
              >
                <Button
                  title="Close"
                  actionKey="print-close"
                  buttonStyle={buttonStyle.LITE}
                  buttonSize={buttonSize.XLG}
                  onClick={actionKey => {
                    this.handleActions(actionKey)
                  }}
                />
              </div>
            </FooterWrapper>
          </div>
        </BodyWrapper>
      </PageMobileWrapper>
    )
  }
}


const mapStateToProps = (state) => {
  return {}
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalePrintResult);
